import { render, staticRenderFns } from "./UsabillaContainer.vue?vue&type=template&id=a977868e&scoped=true"
import script from "./UsabillaContainer.vue?vue&type=script&lang=js"
export * from "./UsabillaContainer.vue?vue&type=script&lang=js"
import style0 from "./UsabillaContainer.vue?vue&type=style&index=0&id=a977868e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a977868e",
  null
  
)

export default component.exports